export const YES_NO_CHOICES = [
  { value: true, name: "Yes" },
  { value: false, name: "No" },
];

// Options for the denture type multi-select field.
export const DENTURE_TYPE_OPTIONS = [
  { value: "Upper full plastic", label: "Upper full plastic" },
  {
    value: "Upper full plastic and metal",
    label: "Upper full plastic and metal",
  },
  { value: "Upper partial plastic", label: "Upper partial plastic" },
  {
    value: "Upper partial plastic and metal",
    label: "Upper partial plastic and metal",
  },
  { value: "Lower full plastic", label: "Lower full plastic" },
  {
    value: "Lower full plastic and metal",
    label: "Lower full plastic and metal",
  },
  { value: "Lower partial plastic", label: "Lower partial plastic" },
  {
    value: "Lower partial plastic and metal",
    label: "Lower partial plastic and metal",
  },
];

// Options for the denture age dropdown.
export const DENTURE_AGE_OPTIONS = [
  { value: "Less than 5 year", name: "Less than 5 year" },
  { value: "More than 5 years", name: "More than 5 years" },
  { value: "Don't know", name: "Don't know" },
];

// Options for the oral health problems multi-select field.
export const ORAL_PROBLEM_OPTIONS = [
  { value: "Difficulty eating", label: "Difficulty eating" },
  { value: "Decayed teeth", label: "Decayed teeth" },
  { value: "Sudden dry mouth", label: "Sudden dry mouth" },
  { value: "Pain in mouth/teeth/gums", label: "Pain in mouth/teeth/gums" },
  { value: "Bleeding gums", label: "Bleeding gums" },
  { value: "Loose teeth", label: "Loose teeth" },
  { value: "Sore/ulcers", label: "Sore/ulcers" },
  { value: "Bad breath", label: "Bad breath" },
  { value: "Other", label: "Other" },
];

// Options for the last dentist visit dropdown.
export const LAST_DENTIST_VISIT_OPTIONS = [
  { value: "Less than 1 months ago", name: "Less than 1 months ago" },
  { value: "More than 1 year ago", name: "More than 1 year ago" },
  { value: "Don't know", name: "Don't know" },
];

// Defines the initial state for the form.
export const initialFormData = {
  care_plan: "",
  has_dentures: false,
  denture_types: [],
  are_dentures_labelled: null,
  denture_age: "",
  has_oral_problems: false,
  oral_problems_list: [],
  oral_problems_description: "",
  requires_urgent_checkup: false,
  urgent_checkup_details: "",
  last_dentist_visit: "",
  is_registered_with_dentist: false,
  action_to_be_taken: "",
};
